import { NgModule } from '@angular/core';

import { FilterService } from './filter.service';
import { DatePipeModule } from 'libraries/date/date.module';
import { LabelModule } from 'libraries/service/label/label.module';
import { DurationPipe } from 'libraries/date/duration.pipe';
import { PricePipeModule } from 'libraries/pipes/price/price-pipe.module';
import { LanguageService } from "libraries/service/language/language.service";

@NgModule({
    imports: [
        DatePipeModule,
        PricePipeModule,
        LabelModule,
    ],
    providers: [
        FilterService,
        DurationPipe,
        LanguageService,
    ],
})
export class FilterServiceModule { }
